import {
    type FC
} from "react";
import type IDropdownMenuCheckboxItemProps from "./type";
import DropdownMenuMark from "../mark";
import DropdownMenuRow from "../row";

const DropdownMenuCheckboxItem: FC<IDropdownMenuCheckboxItemProps> = ({
    isCloseOnSelect = false,
    isDisabled = false,
    isChecked = false,
    customTheme,
    onChange,
    ...props
}) => {
    const handlePress = () => {
        onChange?.(isChecked !== true);
    };

    return <DropdownMenuRow
        {...props}
        ariaChecked={isChecked === "partially" ? "mixed" : isChecked}
        isCloseOnSelect={isCloseOnSelect}
        leading={<DropdownMenuMark
            customTheme={customTheme}
            isDisabled={isDisabled}
            isChecked={isChecked}
            kind="check"
        />}
        customTheme={customTheme}
        role="menuitemcheckbox"
        isDisabled={isDisabled}
        onPress={handlePress}
    />;
};
export default DropdownMenuCheckboxItem;
